import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, of, switchMap } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

export const authGuard: CanActivateFn = (_route, _state) => {
	const authService = inject(AuthenticationService);
	const router = inject(Router);

	return authService.authUser$.pipe(
		switchMap(user => {
			if (!user) {
				return authService.autoAuthUser();
			}
			return of(user);
		}),
		map(user => {
			if (!user) {
				router.navigate(['']);
				return false;
			}
			return true;
		}),
	);
};
